import { Separator, styled, Text } from "tamagui";

import { Card, Progress } from "../../ui";

const AssessmentCardScore = styled(Text, {
  name: "AssessmentCardScore",
  fontWeight: "$4",
  variants: {
    font: {
      lg: {
        fontFamily: "$subtitle",
        fontSize: "$6",
        lineHeight: "$6",
      },
      md: {
        fontFamily: "$body",
        fontSize: "$3",
        lineHeight: "$3",
      },
    },
    state: {
      success: {
        color: "$score-10-9",
      },
      warning: {
        color: "$warning-500",
      },
      neutral: {
        color: "$gray-600",
      },
      danger: {
        color: "$error-500",
      },
    },
  } as const,
  defaultVariants: {
    state: "neutral",
    font: "lg",
  },
});

const AssessmentCardSeparator = styled(Separator, {
  name: "AssessmentCardSeparator",
  vertical: true,
  borderRightWidth: "$0.2",
  borderRightColor: "$gray-200",
});

const AssessmentCardScoreContainer = styled(Text, {
  name: "AssessmentCardScoreContainer",
  fontFamily: "$subtitle",
  fontWeight: "$4",
  fontSize: "$6",
  lineHeight: "$6",
  color: "$gray-100",
});

const AssessmentCardDescription = styled(Text, {
  name: "AssessmentCardDescription",
  fontFamily: "$subtitle",
  fontWeight: "$4",
  fontSize: "$2",
  lineHeight: "$2",
  color: "$gray-primary-900",
});

export const AssessmentCard = {
  Body: Card,
  Progress: Progress,
  Description: AssessmentCardDescription,
  Score: AssessmentCardScore,
  ScoreContainer: AssessmentCardScoreContainer,
  Separator: AssessmentCardSeparator,
};
